import { useAuthStore } from '@/stores/authStore'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from './api'
import { createGoogleLoginPathForReturnTo } from './auth-return-to'

export function useAuth() {
  const store = useAuthStore()
  const queryClient = useQueryClient()
  const query = useQuery({
    queryKey: ['auth', 'me'],
    queryFn: api.me,
    staleTime: 60_000,
  })

  const user = query.data ?? store.user

  return {
    user,
    isLoading: query.isLoading || store.isLoading,
    isAuthenticated: Boolean(user),
    login: (returnTo?: string) => {
      window.location.href = createGoogleLoginPathForReturnTo(returnTo)
    },
    logout: async () => {
      await store.logout()
      await queryClient.cancelQueries({ queryKey: ['auth', 'me'] })
      queryClient.setQueryData(['auth', 'me'], null)
    },
  }
}
